<template>
  <i-select :id="id" :disabled="type" :multiple="shape" :style='st'>
    <i-option v-for="item in cityList" :value="item.value" :key='item.value'>{{ item.label }}</i-option>
  </i-select>
</template>
<script>
import { type, getName } from '../../constants/types'
const component = {
  name: 'hex-select',
  props: {
    id: String,
    type: Boolean,
    shape: Boolean,
    st: Object,
    cityList : {
      default:[
        {
            value: 'beijing',
            label: '北京市'
        },
        {
            value: 'shanghai',
            label: '上海市'
        },
        {
            value: 'shenzhen',
            label: '深圳市'
        },
        {
            value: 'hangzhou',
            label: '杭州市'
        },
        {
            value: 'nanjing',
            label: '南京市'
        },
        {
            value: 'chongqing',
            label: '重庆市'
        }
      ]
    }
  }
}
// 区分editor和实际打包， build之后的lib不打包
if (process.env.MODE === 'editor') {
  component.define = require('./define')
}
export default component
</script>



// WEBPACK FOOTER //
// index.vue?629411fd